<template>
  <span>
    <v-autocomplete
      id="select-groups"
      clearable
      v-model="data"
      :items="items"
      :loading="loading"
      :search-input.sync="search"
      item-text="name"
      item-value="name"
      :placeholder="label"
    ></v-autocomplete>
  </span>
</template>

<script>
import { axios } from '../utils'
export default {
  props: { value: {}, clear: {}, label: { default: 'Search Groups' } },
  data() {
    return {
      items: [],
      data: '',
      loading: false,
      search: null
    }
  },

  watch: {
    search(value) {
      this.loading = true
      axios
        .get(`api/admin/admin-groups?q=${value}`)
        .then(res => {
          this.items = res.data
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false
        })
    },
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
      this.items.push(value)
    },
    clear() {
      console.log('clear here')
      this.items = []
      this.data = ''
    }
  }
}
</script>

<style></style>
